import Api from "../../Services/Api";
import { toastr } from "react-redux-toastr";

export const DOCUMENTNAME = "riskwell/adddocument/DOCUMENTNAME";

export const ADDDOCUMENTSUCCESS = "riskwell/adddocument/ADDDOCUMENTSUCCESS";
export const ADDDOCUMENTFAILURE = "riskwell/adddocument/ADDDOCUMENTFAILURE";

export const RESETDATA = "riskwell/adddocument/RESETDATA";
export const LOGGEDINLOADER = "riskwell/adddocument/LOGGEDINLOADER";

export const DOCUMENTFAILURE = "riskwell/adddocument/DOCUMENTFAILURE";

export const documentName = (documentName) => {
  return {
    type: DOCUMENTNAME,
    payload: documentName,
  };
};

export const DocumentSuccessStatus = (success) => {
  return {
    type: ADDDOCUMENTSUCCESS,
    payload: success,
  };
};

export const DocumentFailureStatus = (message) => {
  return {
    type: ADDDOCUMENTFAILURE,
    payload: message,
  };
};

export const ResetData = () => {
  return {
    type: RESETDATA,
  };
};

export const loggedInLoader = (bool) => {
  return {
    type: LOGGEDINLOADER,
    payload: bool,
  };
};

export const DocumentFailure = (err) => {
  return {
    type: DOCUMENTFAILURE,
    payload: err,
  };
};

export const AddDocument = (formData) => async (dispatch) => {
  try {
    if (formData.length > 0) {
      dispatch(loggedInLoader(true));
      let msgBln = false;
      for (let i = 0; i < formData.length; i++) {
        let result = await Api.addDocument(formData[i]);

        if (result.status === 200) {
          dispatch(ResetData());
          dispatch(DocumentSuccessStatus(result.message));
          //toastr.success("Document uploaded successfully");
          msgBln = true;
        }
        //  else if (result.statusText === "Unauthorized") {
        //   dispatch(DocumentFailure(result.statusText));
        //   toastr.error(result.statusText);
        // } 
        else {
          toastr.error(result.message ? result.message : result.statusText);
          dispatch(
            DocumentFailureStatus(
              result.message ? result.message : result.statusText
            )
          );
        }
      }
      dispatch(loggedInLoader(false));
      if (msgBln) {
        toastr.success("Document uploaded successfully");
        window.location.reload();
      }
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    toastr.error("Document Upload Error");
    dispatch(DocumentFailureStatus("Document Upload Error"));
  }
};

export const commonDocumentUpload = (formData) => async (dispatch) => {
  try {
    if (formData.length > 0) {
      dispatch(loggedInLoader(true));
      let msgBln = false;
      for (let i = 0; i < formData.length; i++) {
        let result = await Api.commonDocumentUpload(formData[i]);

        if (result.status === 200) {
          dispatch(ResetData());
          dispatch(DocumentSuccessStatus(result.message));
          // dispatch(loggedInLoader(false));
          msgBln = true;
        }
        //  else if (result.statusText === "Unauthorized") {
        //   dispatch(DocumentFailure(result.statusText));
        //   toastr.error(result.statusText);
        // }
         else {
          // dispatch(loggedInLoader(false));
          toastr.error(result.message ? result.message : result.statusText);
          dispatch(
            DocumentFailureStatus(
              result.message ? result.message : result.statusText
            )
          );
        }
      }
      dispatch(loggedInLoader(false));
      if (msgBln) {
        toastr.success("Document uploaded successfully");
        window.location.reload();
      }
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    toastr.error("Document Upload Error");
    dispatch(DocumentFailureStatus("Document Upload Error"));
  }
};
